import { CostCenterModelAPI } from '../../../../models';
import { getCostCenterGroupAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

export const CostCentersAPI = {
    costCentersByGruop: (groupID: number) => {
        return requests
            .get('/jerusalem/api/v2.0.0/cost-centers/cost-centers-group/' + groupID)
            .then((response: CostCenterModelAPI[]) =>
                getCostCenterGroupAdapter(response)
            );
    },
};
